import { Injectable, PLATFORM_ID, inject } from '@angular/core';
import { isPlatformBrowser, DOCUMENT } from '@angular/common';

export type LazyCssBundle =
  | 'lazy-owl-carousel'
  | 'lazy-owl-theme'
  | 'lazy-videojs'
  | 'lazy-emoji-mart'
  | 'lazy-flag-icons'
  | 'lazy-primeng-theme';

@Injectable({ providedIn: 'root' })
export class LazyCssLoaderService {
  private loaded = new Set<string>();
  private platformId = inject(PLATFORM_ID);
  private document = inject(DOCUMENT);

  load(...bundles: LazyCssBundle[]): void {
    if (!isPlatformBrowser(this.platformId)) return;

    bundles.forEach(bundle => {
      if (this.loaded.has(bundle)) return;
      this.loaded.add(bundle);

      const link = this.document.createElement('link');
      link.rel = 'stylesheet';
      link.type = 'text/css';
      link.href = `/${bundle}.css`;
      link.onerror = () => console.error(`[LazyCss] Failed to load: ${bundle}.css`);
      this.document.head.appendChild(link);
    });
  }

  loadForVideoPlayer(): void {
    this.load('lazy-videojs');
  }

  loadForCarousel(): void {
    this.load('lazy-owl-carousel', 'lazy-owl-theme');
  }

  loadForPrimeNG(): void {
    this.load('lazy-primeng-theme');
  }

  loadForFlagIcons(): void {
    this.load('lazy-flag-icons');
  }

  loadForEmojiMart(): void {
    this.load('lazy-emoji-mart');
  }
}
